// Dependencias
import { Config } from 'datatables.net-bs5';

export const generalConfig: Config = {
  // Configuración básica para la tabla
  searching: false,
  pagingType: 'simple',
  dom: 'plftr',
  info: true,
  // Traducciones de datos de la tabla
  language: {
    decimal: ',',
    emptyTable: 'No hay datos disponibles en la tabla',
    info: 'Mostrando _START_ a _END_ de _TOTAL_ entradas',
    infoEmpty: 'Mostrando 0 a 0 de 0 entradas',
    infoFiltered: '(filtrado de _MAX_ entradas totales)',
    lengthMenu: 'Mostrar _MENU_ entradas',
    loadingRecords: 'Cargando...',
    processing: 'Procesando...',
    search: 'Buscar:',
    zeroRecords: 'No se encontraron registros coincidentes',
    paginate: {
      first: 'Primero',
      last: 'Último',
      next: '<i class="bi bi-arrow-right"></i>',
      previous: '<i class="bi bi-arrow-left"></i>'
    }
  },
  lengthMenu: [10, 15, 20, 25, 50, 100, 250, 500, 1000]
};
